module.exports = __webpack_public_path__ + "static/media/add-reservtion-icon.67e9c868.svg";